/* eslint-disable import/prefer-default-export */
import config from "@Config/index";
import LangChinaFlag from "@Icons/LangChinaFlag";
import LangEnglishUKFlag from "@Icons/LangEnglishUKFlag";
import LangFranceFlag from "@Icons/LangFranceFlag";
import LangGermanyFlag from "@Icons/LangGermanyFlag";
import LangSpainFlag from "@Icons/LangSpainFlag";

export interface LanguageConfig {
  name: string;
  code: string;
  nativeLabel: string;
  domains: string[];
  flag: any;
  shortDisplayText: string;
  hasRegionalBlog?: boolean;
}

export const languagesForAmberUserWebsite: LanguageConfig[] = [
  {
    name: "english",
    nativeLabel: "English",
    code: "en",
    domains: config.isProduction
      ? ["amberstudent.com", "hk.amberstudent.com"]
      : ["staging-amber.com", "hk.staging-amber.com", "localhost"],
    flag: LangEnglishUKFlag,
    shortDisplayText: "En",
  },
  {
    name: "chinese-simplified",
    nativeLabel: "简体中文",
    code: "zh",
    domains: config.isProduction
      ? ["amberstudent.cn"]
      : ["staging-ali.amberstudent.cn", "china.staging-amber.com"],
    flag: LangChinaFlag,
    shortDisplayText: "中文",
  },
  {
    name: "french",
    nativeLabel: "French",
    code: "fr",
    domains: config.isProduction
      ? ["amberstudent.com", "hk.amberstudent.com"]
      : ["staging-amber.com", "hk.staging-amber.com"],
    flag: LangFranceFlag,
    shortDisplayText: "Fr",
    hasRegionalBlog: true,
  },
  {
    name: "spanish",
    nativeLabel: "Spanish",
    code: "es",
    domains: config.isProduction
      ? ["amberstudent.com", "hk.amberstudent.com"]
      : ["staging-amber.com", "hk.staging-amber.com"],
    flag: LangSpainFlag,

    shortDisplayText: "Es",
    hasRegionalBlog: true,
  },
  {
    name: "german",
    nativeLabel: "German",
    code: "de",
    domains: config.isProduction
      ? ["amberstudent.com", "hk.amberstudent.com"]
      : ["staging-amber.com", "hk.staging-amber.com", "localhost"],
    flag: LangGermanyFlag,
    shortDisplayText: "De",
    hasRegionalBlog: true,
  },
];

export const SUPPORTED_LANG_VALUES = languagesForAmberUserWebsite.map((lang) => lang.code);

export const REGIONAL_BLOG_LANG_VALUES = languagesForAmberUserWebsite
  .filter((lang) => lang.hasRegionalBlog)
  .map((lang) => lang.code);
